import { Fragment, useState } from 'react';
import {
    Create, SimpleForm, useTranslate,
    Toolbar, SaveButton,
    Button, AutocompleteInput, useNotify, useRefresh,
} from 'react-admin';
import axios from 'axios';
import { makeStyles } from '@mui/styles';
import { Launch, Send } from '@material-ui/icons';
import { Box, Dialog, DialogContent, DialogTitle } from '@mui/material';
import { HandleError, ViewTitle } from '../../components';
import { Cancel } from '@mui/icons-material';

const useStyles = makeStyles((theme) => ({
    toolbar: {
        display: 'flex',
    },
    buttonMarginLeft: {
        marginLeft: 10
    },
    flexBox: {
        width: 'auto',
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
    },
    templateInput: {
        width: '300px',
    },
}));

const Validate = (values) => {
    const errors = {};
    if (!values.pod) errors.pod = 'ra.validation.required';
    //if (!values.instanceTemplate) errors.instanceTemplate = 'ra.validation.required';
    return errors;
};

const DeployFirewallTemplate = ({ permissions, ...props }) => {
    const classes = useStyles();
    const translate = useTranslate();
    const [showDialog, setShowDialog] = useState(false);

    const podId = props.pod.id;
    const podName = props.pod.podName;

    const notify = useNotify();
    const refresh = useRefresh();

    const DeployTemplate = async (data) => {
        try {
            const options = {
                headers: {},
            };

            const sendData = {

            };

            const token = localStorage.getItem('token');
            options.headers.Authorization = `Bearer ${token}`;

            const res = await axios.post(`/api/v1/pods/${podId}/createFirewall`, sendData, options);
            handleCloseClick();
            if (res.status !== 201) {
                notify(translate('app.instanceTemplates.deploy.errorMessage'), { type: 'error' });
            }
            else {
                notify(translate('app.instanceTemplates.deploy.successMessage'), { type: 'success' });
                handleCloseClick();
                refresh();
            }
        }
        catch (error) {
            HandleError(error, notify);
        }
    };

    const handleClick = () => {
        setShowDialog(true);
    };

    const handleCloseClick = () => {
        setShowDialog(false);
    };

    const postDefaultValue = () => ({
        pod: podName,
        //instanceTemplate: firewallTemplateId, // Always set this to the firewall template ID
        visibility: ['admin', 'designer', 'trainer', 'trainee'],
    });

    const CreateToolbar = (props) => {
        return (
            <Toolbar className={classes.toolbar}>
                <Button label="ra.action.cancel" size="medium" onClick={handleCloseClick} className={classes.border} >
                    <Cancel />
                </Button>
                <SaveButton label={translate('app.buttons.deploy')} className={classes.buttonMarginLeft} />
            </Toolbar>
        );
    };

    return (
        <Fragment>
            <Button label={translate('app.trainingTemplates.deploy.button')} onClick={handleClick}><Send /></Button>
            <Dialog
                fullWidth
                open={showDialog}
                onClose={handleCloseClick}
                aria-label={translate('app.instanceTemplates.deploy.title')}
            >
                <DialogTitle>
                    <ViewTitle label={translate('app.instanceTemplates.deploy.firewallTitle')} icon={Launch} />
                </DialogTitle>
                <DialogContent>
                    <Create>
                        <SimpleForm validate={Validate} toolbar={<CreateToolbar />} defaultValues={postDefaultValue}
                            onSubmit={DeployTemplate}>

                            <Box className={classes.flexBox}>
                                <AutocompleteInput
                                    source="pod"
                                    isRequired
                                    choices={[{ id: podId, name: podName }]}
                                    optionText="name"
                                    className={classes.templateInput}
                                    optionValue="id"
                                    defaultValue={{ id: podId, name: podName }} // Ensure pod value is set automatically
                                />
                            </Box>

                        </SimpleForm>
                    </Create>
                </DialogContent>
            </Dialog>
        </Fragment>
    );
};

export default DeployFirewallTemplate;
